<fui-edit-form-context>
    <fui-rows [formGroup]="formGroup">
        <fui-row>
            <fui-column>
                <wbo-mix-and-match-inclusion-single-select-edit-control [label]="'wbo.mix-and-match.edit.field.inclusions.id.label'"
                                                                      [placeholder]="'wbo.mix-and-match.edit.field.inclusions.id.placeholder'"
                                                                      [allowClearSelectionOption]="false"
                                                                      [inclusion]="inclusion"></wbo-mix-and-match-inclusion-single-select-edit-control>
                <fui-tandem-field>
                    <wbo-text-edit-control [label]="detailLabel" [placeholder]="detailPlaceholder"
                                           [value]="inclusion.detail"
                                           [readonly]="true"></wbo-text-edit-control>
                    <wbo-currency-edit-control [label]="'wbo.mix-and-match.edit.field.inclusions.price.label'"
                                               [placeholder]="'wbo.mix-and-match.edit.field.inclusions.price.placeholder'"
                                               [value]="inclusion.price"
                                               [readonly]="true"></wbo-currency-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-row>
        <fui-row>
            <fui-column [label]="'wbo.mix-and-match.edit.field-set.inclusions.limits'">
                <wbo-checkbox-edit-control formControlName="includeCompositeComponents"
                                           [(ngModel)]="inclusion.includeCompositeComponents"></wbo-checkbox-edit-control>
                <wbo-checkbox-edit-control formControlName="required"
                                           [(ngModel)]="inclusion.required"></wbo-checkbox-edit-control>
                <wbo-numeric-edit-control formControlName="minProductQty"
                                          [(ngModel)]="inclusion.minProductQty"></wbo-numeric-edit-control>
                <wbo-numeric-edit-control formControlName="maxProductQty"
                                          [(ngModel)]="inclusion.maxProductQty"></wbo-numeric-edit-control>
                <wbo-numeric-edit-control formControlName="discountableQty"
                                          [(ngModel)]="inclusion.discountableQty"></wbo-numeric-edit-control>
            </fui-column>
        </fui-row>
        <fui-row>
            <fui-column [label]="'wbo.mix-and-match.edit.field-set.inclusions.requiredExtras'">
                <ng-container formGroupName="extra">
                    <wbo-extra-single-select-edit-control formControlName="id"
                                                          (valueChange)="extraValueChange($event)"
                                                          [objectValue]="inclusion.extra"
                                                          [(ngModel)]="inclusion.extra.id"></wbo-extra-single-select-edit-control>
                </ng-container>
                <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                <ng-container formGroupName="extraCustomObject">
                    <wbo-custom-object-single-select-edit-control [productLineContext]="true"
                                                                  formControlName="customObjectId"
                                                                  (valueChange)="extraCustomObjectValueChange($event)"
                                                                  [objectValue]="inclusion.extraCustomObject"
                                                                  [(ngModel)]="inclusion.extraCustomObject.customObjectId"></wbo-custom-object-single-select-edit-control>
                </ng-container>
                <fui-column class="light-group">
                    <wbo-numeric-edit-control formControlName="minExtraQty"
                                              (valueChange)="minExtraQtyChanged($event)"
                                              [(ngModel)]="inclusion.minExtraQty"></wbo-numeric-edit-control>
                    <wbo-numeric-edit-control formControlName="maxExtraQty"
                                              (valueChange)="maxExtraQtyChanged($event)"
                                              [(ngModel)]="inclusion.maxExtraQty"></wbo-numeric-edit-control>
                </fui-column>
            </fui-column>
        </fui-row>
        <fui-row *ngIf="mixAndMatch.discountExtras">
            <fui-column [label]="'wbo.mix-and-match.edit.field-set.inclusions.discountedExtras'">
                <ng-container formGroupName="discountableExtra">
                    <wbo-extra-single-select-edit-control formControlName="id"
                                                          (valueChange)="discountableExtraValueChange($event)"
                                                          [objectValue]="inclusion.discountableExtra"
                                                          [(ngModel)]="inclusion.discountableExtra.id"></wbo-extra-single-select-edit-control>
                </ng-container>
                <fui-message-label [title]="'wbo.common.label.or'"></fui-message-label>
                <ng-container formGroupName="discountableExtraCustomObject">
                    <wbo-custom-object-single-select-edit-control [productLineContext]="true"
                                                                  formControlName="customObjectId"
                                                                  (valueChange)="discountableExtraCustomObjectValueChange($event)"
                                                                  [objectValue]="inclusion.discountableExtraCustomObject"
                                                                  [(ngModel)]="inclusion.discountableExtraCustomObject.customObjectId"></wbo-custom-object-single-select-edit-control>
                </ng-container>
                <fui-inline-information *ngIf="!inclusion.discountableExtra?.id && !inclusion.discountableExtraCustomObject?.customObjectId" [title]="'wbo.common.info.information'"
                                        [message]="'wbo.mix-and-match.edit.message.discountAllExtras'"></fui-inline-information>
                <fui-inline-warning *ngIf="inclusion.discountableExtra?.id || inclusion.discountableExtraCustomObject?.customObjectId" [title]="'wbo.common.info.warning'"
                                    [message]="'wbo.mix-and-match.edit.message.discountExtras'"></fui-inline-warning>
                <fui-column class="light-group">
                    <wbo-numeric-edit-control formControlName="discountableExtraQty"
                                              [(ngModel)]="inclusion.discountableExtraQty"></wbo-numeric-edit-control>
                </fui-column>
            </fui-column>
        </fui-row>
    </fui-rows>
</fui-edit-form-context>
